<template>
	
	<div v-if="ticket.name">
		
		<div class="status-indicator" :class="statusColour" :title="statusDescription"><ion-icon :name="statusIcon"></ion-icon></div>
		
		<h3 class="ticket-name">{{ ticket.name }}<Button v-if="editButton" type="primary" shape="circle" icon="edit" size="small" @click="onClickEditButton"></Button></h3>
		
		<p><span v-if="ticket.due_date" title="Due date"><ion-icon name="calendar"></ion-icon>{{ ticket.due_date | dateFormatted }}</span><span v-if="showDescription">{{ statusDescription }}</span></p>
		
	</div>
	
	<h2 class="title" v-else>Task</h2>
	
</template>

<script>
	
	export default {
		
		computed: {
			
			statusColour() {
				switch (this.ticket.status) {
					case "Rejected":
						return "red";
					case "Approved":
						return "yellow";
					case "In Progress":
						return "yellow";
					case "Completed":
						return "green";
					case "Finalised":
						return "green";
					default:
						return "blue";
				}
			},
			
			statusIcon() {
				switch (this.ticket.status) {
					case "Rejected":
						return "close";
					case "Approved":
						return "checkmark";
					case "In Progress":
						return "sync";
					case "Completed":
						return "done-all";
					case "Finalised":
						return "sunny";
					default:
						return "time";
				}
			},
			
			statusDescription() {
				switch (this.ticket.status) {
					case "Rejected":
						return "This task has been rejected";
					case "Approved":
						return "This task has been approved";
					case "In Progress":
						return "This task is in progress";
					case "Completed":
						return "This task has been completed";
					case "Finalised":
						return "This task has been finalised";
					default:
						return "This task is pending";
				}
			},
			
		},
		
		props: {
			ticket: { default() { return {}; } },
			editButton: { default: false },
			showDescription: { default: false },
		},
		
		methods: {
			onClickEditButton() {
				this.$emit("on-click-edit-button");
			},
		},
		
	}
	
</script>

<style scoped>
	
	/*
		Wrapper
	*/
	
	div:first-of-type {
		margin-bottom: 20px;
	}
	
	/*
		Status Indicator
	*/
	
	.status-indicator {
		display: block;
		width: 24px;
		height: 24px;
		float: left;
		margin-right: 10px;
		border-radius: 50%;
	}

	.status-indicator ion-icon {
		color: white;
		width: 16px;
		height: 24px;
		top: 0;
		left: 4px;
	}

	.status-indicator.blue {
		background-color: #78A4FA;
	}

	.status-indicator.yellow {
		background-color: #FFC82C;
	}

	.status-indicator.green {
		background-color: #13CE66;
	}

	.status-indicator.red {
		background-color: #FF4949;
	}
	
	/*
		Ticket Name
	*/
	
	.ticket-name {
		line-height: 24px;
		margin: 0;
	}
	
	/*
		Description
	*/
	
	p {
		font-size: 12px;
		line-height: 12px;
		text-align: left;
	}
	
	p span:first-of-type {
		font-weight: 600;
		margin-right: 8px;
	}
	
	/*
		Button
	*/
	
	button {
		float: right;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/TicketTitle.vue